import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

export const TicketCounter = ({ headerTitle, ticketCount, loading }) => {
  if (loading) return <>--</>;
  return (
    <>
      <p className="m-2 text-center">
        <FormattedHTMLMessage id={`adminTicketListPage.header.${headerTitle}`} />
      </p>
      <p className="mb-2 hok-card-counter amount text-center">{ticketCount}</p>
    </>
  );
};
